import { UserInterface } from '../interfaces/user.interface';

export const getUserCreditsLeftHelper = ({ sessions_left: sessionsLeft, subscription }: UserInterface): number =>
  sessionsLeft + (subscription?.creditsBank ?? 0);
